// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3UcdL","box":"WorkspacesBox_box__34k93","node":"WorkspacesBox_node__1ZPl2"};